function heapReady() {
  return typeof window !== 'undefined' && window.heap
}

function callHeap(method, ...args) {
  if (!heapReady()) return
  const fn = window.heap[method]
  if (typeof fn !== 'function') return
  try {
    fn.apply(window.heap, args)
  } catch (err) {
    console.warn(`Heap ${method} failed:`, err)
  }
}

export function identifyHeapUser({ uid, email }) {
  if (!email) return
  const identity = email.trim().toLowerCase()
  callHeap('identify', identity)
  callHeap('addUserProperties', {
    internalUserId: String(uid ?? ''),
    email: identity,
    channel: 'frontend',
  })
}

export function syncHeapCompany(selectedCompany, email) {
  if (!selectedCompany?.id || !email) return
  const companyId = String(selectedCompany.id)
  const plan = Array.isArray(selectedCompany.plan)
    ? selectedCompany.plan.join(',')
    : String(selectedCompany.plan ?? selectedCompany.scfo_plan ?? '')

  // addAccountProperties is server API only — account sync runs in NestJS HeapAnalyticsService
  callHeap('addUserProperties', {
    activeCompanyId: companyId,
    companyName: selectedCompany.name ?? '',
    companyRut: selectedCompany.rut ?? '',
    plan,
    isPaying: Boolean(selectedCompany.suscriptionId),
  })
}

export function trackHeapEvent(event, properties = {}) {
  if (!event) return
  callHeap('track', event, properties)
}

/** Portal-side ApiKey actions (e.g. clipboard copy). Lifecycle events are tracked server-side. */
export function trackApiKeyAction(action, properties = {}) {
  if (!action) return
  trackHeapEvent('ApiKey', {
    action,
    channel: 'frontend',
    ...properties,
  })
}

const SKIP_MODULE_PATHS = new Set(['/', '/logout', '/signin'])

/**
 * Track a portal module view (one event per route change).
 * Uses permission moduleId + human-readable name when available.
 */
export function trackModuleView({ pathname, moduleId, moduleName, companyId } = {}) {
  const path = String(pathname || '').split('?')[0].split('#')[0]
  if (!path || SKIP_MODULE_PATHS.has(path)) return
  if (!moduleId) return

  trackHeapEvent('Module', {
    action: 'viewed',
    moduleId: String(moduleId),
    moduleName: String(moduleName || moduleId),
    path,
    companyId: companyId ? String(companyId) : '',
    channel: 'frontend',
  })
}

export function resetHeapIdentity() {
  callHeap('resetIdentity')
}
